export default "__VITE_ASSET__92ea9ab2__"